var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.82863 12V6.84677H11.8125V5.17742H6.82863V0H5.14718V5.17742H0.1875V6.84677H5.14718V12H6.82863Z","fill":"#F7D18F"}));
}

Plus.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
